import { gql } from "@apollo/client";

export const genreQuery = gql`
  query genre($id: ID!) {
    genre(id: $id) {
      id
      name
      abbreviation
    }
  }
`;

export const genreListQuery = gql`
  query genreList {
    genreList {
      id
      name
      abbreviation
    }
  }
`;

export const createGenreMutation = gql`
  mutation createGenre($input: CreateGenreInput!) {
    createGenre(input: $input) {
      id
      name
      abbreviation
    }
  }
`;

export const deleteGenreMutation = gql`
  mutation deleteGenre($input: DeleteGenreInput!) {
    deleteGenre(input: $input) {
      id
      name
      abbreviation
    }
  }
`;

export const updateGenreMutation = gql`
  mutation updateGenre($input: UpdateGenreInput!) {
    updateGenre(input: $input) {
      id
      name
      abbreviation
    }
  }
`;
